import { ReactNode, MouseEvent } from "react"
import { ReactComponent as OpenIcon } from '../../../assets/Icons/chevron/Chevron-Down.svg';
import { ReactComponent as CloseIcon } from '../../../assets/Icons/chevron/Chevron-Up.svg';
import { ReactComponent as ClearIcon } from '../../../assets/Icons/adornments/Close.svg';

export default function FilterBarBtn({
    label,
    value,
    icon,
    isOpen,
    handleOpen, 
    handleClose,
    resetFn,
    id,
}: {
    label: string,
    value: string | string[] | null,
    icon: ReactNode,
    isOpen: boolean,
    handleOpen: (e:any) => void,
    handleClose: (e:any) => void,
    resetFn: () => void,
    id: string,
}) {
    return (
        <button 
            id={id}
            className={`relative flex justify-start items-center gap-4 py-2 px-3 rounded-lg border hover:border-primary hover:text-primary transition-all ${value !== null ? 'border-solid border-primary bg-secondary text-primary' : 'border-dashed border-outline bg-white/[0.5] text-disable'}`} 
            onClick={(e: MouseEvent<HTMLButtonElement>) => {e.stopPropagation(); handleOpen(e)}  }
        >
            <div className="flex justify-start items-center gap-2">
                {value !== null && (
                    <span onClick={(e: MouseEvent<HTMLSpanElement>) => { e.stopPropagation(); resetFn()}} className="relative hover:bg-black/[0.1] z-20 aspect-square border border-primary rounded-full mx-1"><div className="w-[10px]"><ClearIcon /></div></span>
                )}
                <div className="w-[12px]">{icon}</div>
                <p className={`text-[12px] ${value !== null ? 'font-medium' : 'font-normal'}`}><span>{`${label}${value !== null ? ': ' : ''}`}</span></p>
                {value !== null && (
                    <>
                    {typeof value === 'string' ? (
                        <div className="py-1 px-2 rounded bg-white/[0.5] text-primary text-[10px] font-medium">{value}</div>
                    ) : (
                        <>
                            <p className="text-[14px]">{(value as string[]).length} applied</p>
                            {/* {(value as string[]).length < 3 ? (
                                <>
                                {(value as string[]).map(val => (
                                    <div className="py-1 px-2 rounded bg-white/[0.5] text-primary text-[10px] font-medium">{val}</div>
                                ))}
                                </>
                            ) : (
                                <p className="text-[14px]">{(value as string[]).length} applied</p>
                            )} */}
                        </>
                    )}
                    </>
                )}
            </div>
            {value !== null && <div className="w-[12px]">{isOpen ? <CloseIcon /> : <OpenIcon />}</div>}
        </button>
    )
}